<template>
    <div class="article" style="background:#fff;">
        <div class="inner_banner big_screen" v-if="aid != 426526514995269">
            <div class="ant-image">
                <img class="ant-image-img" v-if="id==426176045379653 || id==426173197115461 || id==426175958732869" src="/imgs/banner_inner_06.png">
            </div>
            <div class="wid" style="position:absolute;top:0;right:20%;">
                <span class="word" v-if="id==426176045379653">殡葬文件</span>
                <span class="word" v-if="id==426173197115461">行业新闻</span>
                <span class="word" v-if="id==426175958732869">政策法规</span>
            </div>
        </div>
        <div class="wid">
            <div v-if="aid != 426526514995269" class="ant-breadcrumb">
                <span>
                    <span class="ant-breadcrumb-link">当前位置：</span>
                </span>
                <span>
                    <span class="ant-breadcrumb-link">
                        <span>
                        <router-link :to="{'name':'home'}" class="home">网站首页</router-link>
                        </span>
                    </span>
                    <span class="ant-breadcrumb-separator">&gt;</span>
                </span>
                <span><router-link :to="{'name':'list',query:{id:'426176045379653'}}">殡葬文化</router-link>
                    <span class="ant-breadcrumb-separator">&gt;</span>
                    <span class="ant-breadcrumb-link">新闻中心</span>
                </span>
            </div>
            <div class="ant-list ant-list-split ls">
                <div class="ant-spin-container">
                    <div class="ant-left">
                        <div class="art_content">
                            <div v-html="html"></div>
                            <div v-if="article.src" style="position:absolute; width: 800px; height:600px; top: 10%;">
                                <video class="v" src="/imgs/v.mp4" autoplay controls="controls" width="640" height="360"></video>
                            </div>
                        </div>
                    </div>
                    <div class="ant-right">
                        <div class="title">
                            <h3>殡葬文化</h3>
                            <router-link :to="{path: '/article/list',query:{id:426176045379653}}" class="more">更多&gt;</router-link>
                        </div>
                        <div class="thumb">
                            <img :src="apiUrl + article.headImagerUrl" class="img">
                            <span class="tit">{{article.nt_Title}}</span>
                        </div>
                        <div class="artLst">
                            <ul class="ul">
                                <li v-for="(item) in articleLst" :key="item.id">
                                    <img src="/imgs/ico_star.png"><router-link :to="{path:'article',query:{cId:cid, aid:item.id}}" target="_blank">{{item.nt_Title}}</router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="about_cem title">
                            <h3>相关墓园</h3>
                        </div>
                        <div class="img_ls">
                            <swiper ref="swiper" :options="swiperOptions">
                                <swiper-slide
                                class="swiper-slide_ls"
                                v-for="(item, index) in tenantLst"
                                :key="'swiper' + index"
                                >
                                <div style="display:flex;flex-direction:column;">
                                    <img class="swiper-slide__img" :src="apiUrl + item.homeImage" alt />
                                    <span>{{item.name}}</span>
                                </div>
                                </swiper-slide>
                                <!-- Optional controls -->
                                <div class="swiper-button-prev" slot="button-prev"></div>
                                <div class="swiper-button-next" slot="button-next"></div>
                            </swiper>
                        </div> 
                    </div>
                </div>                    
            </div>
        </div>                          
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "art",
    data(){
        return {
            id: 0,
            aid: 0,
            html: "",
            cid: '',
            article: [],
            articleLst: [],
            tenantLst: [],
            apiUrl: axios.defaults.baseURL,
            swiperOptions: {
                autoplay: 1000,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },          
        }
    },
    created: function(){
        const id = this.$route.query.id;                
        const cid = this.$route.query.cId;          // 类别id
        const aId = this.$route.query.aid;          //文章id
        const tenantId = this.$route.query.tenantId;        //机构id
        this.cid = cid;
        this.id = id;
        this.aid = aId;
        axios({
            url: "/api/TombNotice/detail",
            method: "get",
            params: { Id: aId },
            headers: { Authorization: "Bearer Fhc123456." },
        }).then((res) => {
            if(res && res.data.data){
                let data = res.data.data;
                var reg = /<img [^>]*src=['"]([^'"]+)[^>]*>/gi;
                let content = data.nt_Content;
                let src = '';
                let html = '';
                //如果内容引入了带框架的视频
                if(content.indexOf('iframe') > 0){
                    let regex = /(?<=(src="))[^"]*?(?=")/ig;
                    src = regex.exec(content);
                    src = src[0];
                    data["src"] = src;
                }
                content.replace(reg);
                html = content.replace("../../",this.apiUrl + "/");
                let article = data;
                this.html = html;
                this.article = article;
            }
        })
        this.noticeQuery(426176045379653);
        this.sysTenantQuery();        
    },
    mounted(){

    },
    methods:{
        noticeQuery(cId){
            axios({
                url: "/api/TombNotice/wxpage",
                method: "get",
                params: { NoticeTypeId: cId, PageSize: 4 },
                headers: { Authorization: "Bearer Fhc123456." },
            }).then((res) => {
                if(res && res.data.data){
                    let data = res.data.data;
                    let rows = data.rows;
                    this.articleLst = rows;
                    this.article = rows[0];
                }
            })
        },
        sysTenantQuery(){
            axios({
                url: "/api/SysTenant_Ext/list",
                params: { tenantType:1 },
                headers: { Authorization: "Bearer Fhc123456.", PageSize: 4 },
            }).then((res) => {
                if(res && res.data.data){
                    let data = res.data.data;
                    this.tenantLst = data;
                }
            })
        }
    }
}
</script>

<style scoped>
.article { background:#f6f6f6; }
.article .ls { margin:0 0 50px; }
.inner_banner, .inner_banner .wid {
    position:relative;
}
.inner_banner {
    height:240px;
    position:relative;
    overflow: hidden;
}
.inner_banner .word {
    position:absolute;
    right:20px;
    top:0;
    margin:90px 0 0;
    font-size:35px;
    color:rgba(2,54,41,1);
}
.inner_banner .word .circle {
    display:inline-block;
    vertical-align: baseline;
    width:24px; height:24px;
    border:3px solid rgba(2,54,41,.6);
    border-radius:50%;
}
.ant-breadcrumb { margin:20px 0; }
.ant-breadcrumb { line-height:1.5; color:rgba(0,0,0,0.45); font-size:14px; }
.ant-breadcrumb-link { color:#555; }
.ant-breadcrumb-separator { margin:0 8px; color:rgba(0,0,0,0.45)}
.ant-breadcrumb>span:last-child .ant-breadcrumb-link { color:#03aaa7; }
.ant-spin-container { 
    display:flex;
    flex-direction:row;
}
.ant-left {
    width:70%;
}
.ant-right {
    margin-left:2%;
    width:30%;
}
.art_content {
    font-size:16px;
    line-height:2.2;
    position: relative;
}
.art_content p {
    font-size:16px;
    line-height:2.2;
}
.thumb {
    width:330px;
    height:215px;
    position:relative;
}
.thumb .img { 
    width:100%;
    height:100%;
}
.thumb .tit {
    position:absolute;
    bottom:5%;
    left:5%;
    color:#fff;
    display: block;
    font-size:16px;
}
.artLst {
    padding:20px 0;
}
.artLst ul { display:flex; flex-direction: column; }
.artLst ul li { line-height: 2.2; display:flex; align-items: center; }
.artLst ul li a { color:#262626; font-size:14px; padding:0 15px; }
.swiper-container {
    width: 300px;
    height: 300px;
    margin: 20px auto;
}
.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}
</style>